import { render } from "./LdDetailOverlay.vue?vue&type=template&id=536cbff8&scoped=true"
import script from "./LdDetailOverlay.vue?vue&type=script&lang=js"
export * from "./LdDetailOverlay.vue?vue&type=script&lang=js"

import "./LdDetailOverlay.vue?vue&type=style&index=0&id=536cbff8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536cbff8"]])

export default __exports__